/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
// import HttpService from '../../utils/httpService';
import { assetbaseUrl } from '../../utils/httpService';
import { invrelFetchData } from '../../redux/actions/inv-relAction';

const PagesInvestorRelation = () => {
    const dispatch = useDispatch();
    const invList = useSelector((state) => state?.InvRelReducer);
    const loading = invList?.loading;
    const [inv, setInv] = React.useState('');

    React.useEffect(() => {
        dispatch(invrelFetchData());
    }, []);

    React.useEffect(() => {
        setInv(invList?.data)
    }, [invList]);

    return (
        <>
            <Helmet>
                <title>Investor Relations | Sandesh</title>
            </Helmet>
            <section className="investorrelations">
                <div className="container ">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-content" style={{ opacity: (loading) ? 0.5 : 1 }}>
                                <h1>Investor Relations</h1>
                                {
                                    invList && Object.values(inv).map((els, idx) => (
                                        <>
                                            <li>
                                                <a target="_blank" href={assetbaseUrl + els?.path} rel="noreferrer">{els?.name}</a>
                                            </li>
                                        </>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PagesInvestorRelation
